<template>
  <div class="yeji">
    <breadcrumb :breadcrumbList="breadcrumbList2"></breadcrumb>
    <div class="main-content">
      <!-- <topContent></topContent> -->
      <list></list>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import topContent from '../base-ui/top-content/top-content.vue'
import list from '../base-ui/list2/list2.vue'
import { breadcrumbList2 } from '../config'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'

export default defineComponent({
  props: {

  },
  components: {
    topContent,
    list,
    Breadcrumb
  },
  setup() {


    return {
      breadcrumbList2
    }

  }
})
</script>

<style scoped lang="less">
.yeji {
  .main-content {
    padding: 20px;
    margin: 20px;
    background-color: #fff;
  }
}
</style>
